import { render, staticRenderFns } from "./GTicketFormModal.vue?vue&type=template&id=294f155c&"
import script from "./GTicketFormModal.vue?vue&type=script&lang=js&"
export * from "./GTicketFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports